export const ISSUE_MARKERS_MODEL_ID = 'issue-markers';

export interface IssueMarkerUserData {
  readonly markerHashId: number;
}

export function isIssueMarkerUserData(
  value: unknown
): value is IssueMarkerUserData {
  return (
    typeof value === 'object' &&
    value !== null &&
    'markerHashId' in value &&
    typeof value.markerHashId === 'number'
  );
}
